import { Store, StoreStatus } from '../types/store'

export function calculateStoreStatus(store: Store): StoreStatus {
  const { settings } = store

  // 1. Overrides take precedence
  if (settings.forceClosed) return 'closed'
  if (settings.forceOpen) return 'open'
  if (settings.pauseOrdering) return 'paused'

  // 2. Draft check
  if (!settings.isPublished) return 'draft'

  // 3. Schedule logic
  if (!settings.scheduleEnabled) {
    // If published but no schedule and no overrides, default to draft or open?
    // Usually implies manual control, but let's assume 'draft' if not explicitly opened via override
    // unless "Ordering Enabled" toggle is separate.
    // For this logic, let's assume if schedule is disabled, it relies on manual overrides.
    // If no override is set, it's effectively not open.
    return settings.orderingEnabled ? 'open' : 'draft'
  }

  const now = new Date()
  const open = new Date(settings.openDate)
  const close = new Date(settings.closeDate)

  if (now < open) return 'scheduled'
  if (now > close) return 'closed'

  // 4. Closing Soon check
  const thresholdHours = settings.closingSoonThreshold || 24
  const msUntilClose = close.getTime() - now.getTime()
  const hoursUntilClose = msUntilClose / (1000 * 60 * 60)

  if (hoursUntilClose <= thresholdHours && hoursUntilClose > 0) {
    return 'closing-soon'
  }

  return 'open'
}

export function getStatusColor(
  status: StoreStatus,
): 'gray' | 'blue' | 'green' | 'yellow' | 'red' {
  switch (status) {
    case 'draft':
      return 'gray'
    case 'scheduled':
      return 'blue'
    case 'open':
      return 'green'
    case 'closing-soon':
      return 'yellow'
    case 'closed':
      return 'red'
    case 'archived':
      return 'gray'
    case 'paused':
      return 'yellow'
    default:
      return 'gray'
  }
}
